import { useState, useCallback } from 'react';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import isValidUuid from '@zenbusiness/application-commons-utils/isValidUuid';
import CardContent from '@zenbusiness/zui/CardContent';

import { HomeSection } from '#client/components/Section';
import { AssistantUi } from '#client/directEntry/MFEs';
import { consumeVeloResumeThreadUuid } from '#client/utils/veloThreadStorage';

import * as Styled from './VeloChat.style';

function VeloChat() {
  const [threadUuid, setThreadUuid] = useState(consumeVeloResumeThreadUuid);

  const handleThreadChange = useCallback(({ threadUuid: nextThreadUuid }) => {
    setThreadUuid(isValidUuid(nextThreadUuid) ? nextThreadUuid : null);
  }, []);

  const assistantProps = {
    exportName: 'VeloChat',
    origination: 'dashboard-next-up',
    onThreadChange: handleThreadChange,
    ...(threadUuid ? { threadUuid } : {}),
  };

  return (
    <HomeSection title={<FormattedMessage id="dashboard.veloChat.title" />}>
      <Styled.VeloChatWrapper color="default" variant="elevation" elevation={0} data-testid="velo-chat-wrapper">
        <CardContent>
          <AssistantUi {...assistantProps} />
        </CardContent>
      </Styled.VeloChatWrapper>
    </HomeSection>
  );
}

export default VeloChat;
